import * as React from "react";
import { createRoot } from 'react-dom/client';
import { App } from "public_app/app";
import { defaults } from "react-sweet-state";
import { produce } from "immer";
import "style/index.css";
defaults.mutator = function (currentState, producer) { return produce(currentState, producer); };
defaults.devtools = true;
var AppContainer = function () {
    return React.createElement(App, null);
};
var root = createRoot(document.getElementById('root'));
root.render(React.createElement(AppContainer, null));
